import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Userpilot } from 'userpilot'

@Injectable({
    providedIn: 'root'
})
export class UserpilotService {
    initialize(): void {
        Userpilot.initialize(environment.userpilot_token);
    }

    identify(data: any): void {
        Userpilot.identify(data.sub, {
            userName: data.email,
            userId: data.sub,
            email: data.email,
            company: { id: data.organization_id, name: data.organization },
            organisation: data.organization,
        });
    }

    reload(): void {
        Userpilot.reload();
    }
}